<template>
  <div class="main-menu menu-bg-blue-transparent" :class="showFeatureButtons ? 'border-top-right-radius-none' : ''">
    <MMP_UserProfile
      id="userProfile"
      :release_date="release_date"
      :showFeatureButtons="showFeatureButtons"
      :user="user"
      :version="version"
      @getFeatureButtons="$emit('getFeatureButtons', $event)"
    ></MMP_UserProfile>
    <MMP_TabNav
      id="tabnav"
      v-if="homeScreenComponents && mapLayers != null"
      :btnClass="btnClass"
      :customerLayersButtonsCtrl="customerLayersButtonsCtrl"
      :customerProjectId="customerProjectId"
      :cust_layersObj="cust_layersObj"
      :dprVisible="dprVisible"
      :homeScreenComponents="homeScreenComponents"
      :isAdmin="isAdmin"
      :isUshrUser="isUshrUser"
      :layersListMaxHeight="layersListMaxHeight"
      :map="map"
      :mmp_layersObj="mmp_layersObj"
      :projects="projects"
      :spinnerManager="spinnerManager"
      :subNavVisible="subNavVisible"
      :ushrLayersButtonsCtrl="ushrLayersButtonsCtrl"
      :ushrLayersVisible="ushrLayersVisible"
      :user="user"
      :zoomEnded="zoomEnded"
      :zoomLevelCap="zoomLevelCap"
      :showLidarPanel="showLidarPanel"
      :baseMapsOpen="baseMapsOpen"
      :extentsOpen="extentsOpen"
      @clearCurrentPositionsInterval="$emit('clearCurrentPositionsInterval')"
      @getCustomerCoverageLayers="$emit('getCustomerCoverageLayers')"
      @initAdminConsole="$emit('initAdminConsole')"
      @initEntryManager="$emit('initEntryManager')"
      @initGTPModal="$emit('initGTPModal')"
      @initHDTAdminConsole="$emit('initHDTAdminConsole')"
      @initReportConsole="$emit('initReportConsole')"
      @layerButtonsChanged="$emit('layerButtonsChanged', $event)"
      @loadProject="$emit('loadProject', $event)"
      @mainMenuSizeChange="$emit('mainMenuSizeChange')"
      @onResize="$emit('onResize')"
      @showCustomerLayer="$emit('showCustomerLayer', $event)"
      @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)"
      @toTopOfList="$emit('toTopOfList', $event)"
      @updateZoomEnded="$emit('updateZoomEnded', $event)"
      @initImageCarousel="$emit('initImageCarousel')"
      @initEODFieldReviewCarousel = "$emit('initEODFieldReviewCarousel')"
      @initGTPReportModal="$emit('initGTPReportModal')"
      @initWmsModal="$emit('initWmsModal')"
      @initAnalytics="$emit('initAnalytics')"
      @initWCL="$emit('initWCL')"
      @initDataTool="$emit('initDataTool')"
      @initSI="$emit('initSI')"
      @initSales="$emit('initSales')"
    ></MMP_TabNav>
  </div>
</template>

<script>
import MMP_TabNav from './MMP_TabNav.vue'
import MMP_UserProfile from './MMP_UserProfile.vue'
export default {
  name: 'MMP_MainMenu',
  components: {
    MMP_TabNav,
    MMP_UserProfile
  },
  props: [
    'btnClass',
    'customerLayersButtonsCtrl',
    'customerProjectId',
    'cust_layersObj',
    'dprVisible',
    'homeScreenComponents',
    'isAdmin',
    'isUshrUser',
    'layersListMaxHeight',
    'map',
    'mapLayers',
    'mmp_layersObj',
    'projects',
    'release_date',
    'spinnerManager',
    'subNavVisible',
    'ushrLayersButtonsCtrl',
    'ushrLayersVisible',
    'user',
    'version',
    'zoomEnded',
    'zoomLevelCap',
    'showFeatureButtons',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen'
  ]
}
</script>
